import { fromTheme } from '@kyruus/ui-theme';
import styled from '@emotion/styled';

export const ShimmerBase = styled(`div`)`
  border-radius: 2px;
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${fromTheme('color_background_secondary')};
  background: linear-gradient(
    to right,
    ${fromTheme('color_button_secondary')} 10%,
    ${fromTheme('color_background_disabled_form_input')} 18%,
    ${fromTheme('color_button_secondary')} 33%
  );
  background-size: 1000px 640px;
  height: 100%;
  position: relative;
`;

export const Container = styled('div')`
  width: 100%;
  height: 100%;
`;

export const LoadingContainer = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
`;

export const ContentHeader = styled('div')`
  height: 2rem;
`;

export const ContentText = styled('div')`
  display: flex;
  margin-top: ${fromTheme('spacing_medium')};

  width: 70%;
  justify-content: space-between;
  > div {
    width: 47%;
    height: 2rem;
  }
`;

export const ContentLabel = styled('div')`
  margin-top: ${fromTheme('spacing_medium')};
  height: 2rem;
  margin-bottom: ${fromTheme('spacing_small')};
  width: 40%;
`;

export const ContentInputRow = styled('div')`
  display: flex;
  margin-top: ${fromTheme('spacing_small')};
  width: 70%;
  justify-content: space-between;
  > div {
    flex: 1 1 auto;
    margin-right: ${fromTheme('spacing_small')};
    height: 2rem;
  }
`;

export const LoadingMain = styled('div')`
  flex: 1 0 auto;
`;

export const LoadingContent = styled('div')`
  width: 50%;
`;

export const LoadingSidebar = styled('div')`
  border-radius: 2px;
  border: 1px solid ${fromTheme('color_background_disabled_form_input')};
  padding: ${fromTheme('spacing_medium')};
  width: 25%;
  display: flex;
  align-self: flex-end;
`;

export const SidebarProfilePic = styled('div')`
  width: 25%;
  margin-right: ${fromTheme('spacing_small')};
`;
export const SidebarInfo = styled('div')`
  flex: 1;

  > div {
    width: 100%;
    height: 1.2rem;
    margin-bottom: ${fromTheme('spacing_small')};
    &:last-child {
      width: 80%;
      margin-bottom: ${fromTheme('spacing_large')};
    }
  }
`;

export const LoadingCell = styled(ShimmerBase)``;

export const BodyContainer = styled('div')`
  padding: ${fromTheme('spacing_large')} ${fromTheme('spacing_large')}
    ${fromTheme('spacing_medium')} ${fromTheme('spacing_large')};
  position: relative;
  margin: 0 auto;
`;
